import { AlertCircle, Pencil, Phone } from 'lucide-react'
import { Link } from 'react-router-dom'

import { EditableField, EditableValue } from '@/customer/components/editable-field'
import { VerificationBadge } from '@/customer/components/member/verification-badge'
import { Alert, AlertTitle } from '@/customer/components/ui/alert'
import { Button } from '@/customer/components/ui/button'
import { useGetMe } from '@/customer/hooks/use-get-me'
import { routes } from '@/customer/routes'

/**
 * Portal phone number field.
 *
 * Display-only wrapper that reads the member's phone + verification
 * timestamp from the `/portal/me` snapshot and points the Edit
 * affordance at the dedicated update-phone page.
 */
export function PhoneProfileField() {
  const me = useGetMe()

  if (!me.data) return null

  const { phone, phoneVerified } = me.data.member
  const isVerified = phoneVerified

  return (
    <EditableField
      label="Phone number"
      icon={Phone}
      action={
        <Button
          type="button"
          variant="ghost"
          size="icon-sm"
          aria-label="Edit phone number"
          className="text-muted-foreground hover:text-foreground"
          render={<Link to={routes.account.phone.update} />}
        >
          <Pencil className="size-3.5" />
        </Button>
      }
    >
      <EditableValue>
        <span className="flex flex-col gap-2">
          <span className="flex items-center gap-2">
            {phone || <span className="text-muted-foreground">Not set</span>}
            {phone ? <VerificationBadge verified={isVerified} /> : null}
          </span>
          {phone && !isVerified ? (
            <Alert variant="warning">
              <AlertCircle />
              <AlertTitle>
                Please{' '}
                <Link
                  to={routes.account.phone.verify}
                  className="font-semibold underline underline-offset-4"
                >
                  verify your phone number.
                </Link>
              </AlertTitle>
            </Alert>
          ) : null}
        </span>
      </EditableValue>
    </EditableField>
  )
}
